import { DateTime } from 'aws-sdk/clients/devicefarm';
import { BaseRequest } from './BaseRequest';

export class ActiveCampaignRequest extends BaseRequest {
    StartDateTime: DateTime;
    EndDateTime: DateTime;
    VolumeMessages: number;
    CampaignType?: string;
}